export default __webpack_public_path__ + "static/center-tr-8e40cc3365979c81079ed686c6bb2904.webp";